import IMAGE from 'constants/images';
import ENVIRONMENTS from 'constants/enviroments';

const operator = {
  Redenção: {
    logo: IMAGE.ILLUSTRATION.REDENCAO_LOGO_TWO,
    logoDisabled: IMAGE.ILLUSTRATION.REDENCAO_LOGO_DISABLED_TWO,
    operatorBackground: IMAGE.BACKGROUND_IMAGES.REDENCAO_ILUSTRATION_LARGE_TWO,
    vehicle: IMAGE.ILLUSTRATION.BUS_REDENCAO_TWO,
    vehicleDisable: IMAGE.ILLUSTRATION.DISABLED_BUS_REDENCAO_TWO,
    ticketSent: IMAGE.ILLUSTRATION.TICKET_SENT,
  },
  'São Paulo': {
    logo: IMAGE.ILLUSTRATION.REDENCAO_LOGO,
    logoDisabled: IMAGE.ILLUSTRATION.REDENCAO_LOGO_DISABLED,
    operatorBackground: IMAGE.BACKGROUND_IMAGES.REDENCAO_ILUSTRATION_LARGE,
    vehicle: IMAGE.ILLUSTRATION.BUS_REDENCAO,
    vehicleDisable: IMAGE.ILLUSTRATION.DISABLED_BUS_REDENCAO,
    ticketSent: IMAGE.ILLUSTRATION.TICKET_SENT,
  },
  ITS: {
    logo: IMAGE.ILLUSTRATION.ITS_LOGO,
    logoDisabled: IMAGE.ILLUSTRATION.ITS_LOGO_DISABLED,
    operatorBackground: IMAGE.BACKGROUND_IMAGES.VESSELS_ILUSTRATION_LARGE,
    vehicle: IMAGE.ILLUSTRATION.VESSEL,
    vehicleDisable: IMAGE.ILLUSTRATION.DISABLED_VESSEL,
    ticketSent: IMAGE.ILLUSTRATION.TICKET_SENT,
  },
  'ONBOARD Homolog': {
    logo: IMAGE.ILLUSTRATION.ITS_LOGO,
    logoDisabled: IMAGE.ILLUSTRATION.ITS_LOGO_DISABLED,
    operatorBackground: IMAGE.BACKGROUND_IMAGES.VESSELS_ILUSTRATION_LARGE,
    vehicle: IMAGE.ILLUSTRATION.VESSEL,
    vehicleDisable: IMAGE.ILLUSTRATION.DISABLED_VESSEL,
    ticketSent: IMAGE.ILLUSTRATION.TICKET_SENT,
  },
  Catsul: {
    logo: IMAGE.ILLUSTRATION.CATSUL_LOGO,
    logoDisabled: IMAGE.ILLUSTRATION.CATSUL_LOGO_DISABLED,
    operatorBackground: IMAGE.BACKGROUND_IMAGES.IMAGE_BACKGROUND_CATSUL,
    vehicle: IMAGE.ILLUSTRATION.IMAGE_CARDS_CATSUL,
    vehicleDisable: IMAGE.ILLUSTRATION.IMAGE_CARDS_CATSUL_DISABLED,
    ticketSent: IMAGE.ILLUSTRATION.TICKET_SENT_CATSUL,
  },
};
const key = ENVIRONMENTS.OPERATOR as keyof typeof operator;
const operatorSelected = operator?.[key]
  ? operator?.[key]
  : operator['São Paulo'];
const { logo } = operatorSelected;
const { logoDisabled } = operatorSelected;
const { operatorBackground } = operatorSelected;
const { vehicle } = operatorSelected;
const { vehicleDisable } = operatorSelected;
const { ticketSent } = operatorSelected;

export { logo, logoDisabled, operatorBackground, vehicle, vehicleDisable, ticketSent };
